import React from "react";
import {useAtom} from "jotai";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, Stack,
} from "@mui/material";
import {ConfirmModalAtom} from "../../utils/atoms";
import {CancelButton} from "../buttons/cancel-button";
import {SubmitButton} from "../buttons/submit-button";
import Modal from "@mui/material/Modal";

export const defaultStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 300, maxWidth: 400,
  bgcolor: '#FEFEFE',
  borderRadius: 4,
  boxShadow: 1,
  p: 2,
  "&:focus-visible": {border: "0 !important", outline: "none"},
  "&:focus": {
    border: "0px !important",
    outline: "none"
  }
};


export const ConfirmDialogModal = () => {
  const [dialog, setDialog] = useAtom(ConfirmModalAtom);

  const handleClose = () => {
    setDialog((prev) => ({...prev, open: false}));
  };

  const handleConfirm = () => {
    dialog.resolve(true); // Resolve the promise with true
    handleClose();
  };

  const handleCancel = () => {
    dialog.resolve(false); // Resolve the promise with false
    handleClose();
  };

  return (
    <Modal
      open={dialog?.open}
      onClose={handleCancel}
      slotProps={{
        backdrop: {
          sx: {
            bgcolor: "transparent",
            backdropFilter: "blur(4px)",
          },
          className: "modal-gradient-bg"
        }
      }}
    >
      <Stack direction="column" sx={{...defaultStyle, minWidth: "300px", maxWidth: "sm", width: "auto"}}>
        <DialogTitle sx={{fontSize: "1.3rem"}}>{dialog.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialog.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleCancel} sx={{...(dialog?.cancelStyle || {})}}>
            {dialog?.cancelText || "Cancel"}
          </CancelButton>
          <SubmitButton onClick={handleConfirm} color="primary" variant="contained" sx={{...(dialog?.confirmStyle || {})}}>
            {dialog?.confirmText || "Yes, continue"}
          </SubmitButton>
        </DialogActions>
      </Stack>
    </Modal>
  );
};
